import React from 'react';
import {
  TagTopic,
  CarouselCardProps,
} from './types/SectionFilterableArticles.types';
import {
  CustomCarouselCard,
  IconWrapper,
  TopicCarouselCard,
  TopicCarouselWrapper,
} from './styles/TopicCarousel.styles';
import Icon from '@legacy-vfuk/core-icon';
import CardCarousel from '@legacy-vfuk/core-card-carousel';
import { compareTopicsByViewCount } from '../../../../helpers/articleHelpers';

export type TopicCarouselProps = {
  forYouLabel?: string;
  allLabel?: string;
  savedLabel?: string;
  topics: TagTopic[];
  selectedTopics: TagTopic[];
  handleForYouClicked: (slugName: string) => void;
  handleSavedClicked: (slugName: string) => void;
  handleTopicFiltered: (slugName: string) => void;
  handleAllTopicsClick: () => void;
  allFilterSelected: boolean;
};

const TopicCarousel = ({
  forYouLabel,
  allLabel,
  savedLabel,
  topics,
  selectedTopics,
  handleForYouClicked,
  handleSavedClicked,
  handleTopicFiltered,
  handleAllTopicsClick,
  allFilterSelected,
}: TopicCarouselProps) => {
  const handleSelectedTopic = (topic: TagTopic) => {
    handleTopicFiltered(topic.slugName);
  };

  const sortedTopics = [...topics].sort(compareTopicsByViewCount);
  const topicFilterStates = sortedTopics.map(topic =>
    selectedTopics.some(t => t.slugName === topic.slugName)
  );

  const cardData: any = [];

  if (forYouLabel) {
    cardData.push({
      type: 'for-you',
    });
    topicFilterStates.unshift(false);
  }

  if (savedLabel) {
    cardData.push({
      type: 'saved',
    });
    topicFilterStates.unshift(false);
  }

  cardData.push(...sortedTopics);

  if (allLabel) {
    cardData.push({
      type: 'all',
    });
    topicFilterStates.push(false);
  }

  const carouselCards = cardData.map(
    (card: CarouselCardProps, index: number) => {
      if (card.type === 'for-you') {
        return (
          <CustomCarouselCard
            onClick={() => {
              handleForYouClicked('');
            }}
            isDisabled={false}
            key={card.type}
          >
            <div>
              <IconWrapper>
                <Icon
                  name="admin"
                  size={4}
                  appearance="primary"
                  inverse={false}
                />
              </IconWrapper>
              <p style={{ color: '#E60000' }}>{forYouLabel}</p>
            </div>
          </CustomCarouselCard>
        );
      } else if (card.type === 'saved') { 
        return (
          <CustomCarouselCard
            onClick={() => {
              handleSavedClicked('');
            }}
            isDisabled={false}
            key={card.type}
          >
            <div>
              <IconWrapper>
                <Icon
                  name="bookmark"
                  size={4}
                  appearance="primary"
                  inverse={false}
                />
              </IconWrapper>
              <p>{savedLabel}</p>
            </div>
          </CustomCarouselCard>
        );
      } else if (card.type === 'all') {
        return (
          <TopicCarouselCard
            key={card.type}
            onClick={handleAllTopicsClick}
            isSelected={allFilterSelected}
          >
            <div>
              <IconWrapper>
                <Icon
                  name="connectivity"
                  size={4}
                  appearance="primary"
                  inverse={false}
                />
              </IconWrapper>
              <p>{allLabel}</p>
            </div>
          </TopicCarouselCard>
        );
      } else {
        return (
          <TopicCarouselCard
            key={card.slugName}
            data-view-count={card.viewCount}
            onClick={() => handleSelectedTopic(card as TagTopic)}
            isSelected={topicFilterStates[index]}
          >
            <div>
              <IconWrapper>
                <Icon
                  name={card.iconName ? card.iconName : ''}
                  size={4}
                  appearance="primary"
                  inverse={false}
                />
              </IconWrapper>
              <p>{card.displayName}</p>
            </div>
          </TopicCarouselCard>
        );
      }
    }
  );

  return (
    <TopicCarouselWrapper>
      <CardCarousel
        srName="carousel-article"
        slidesToShow={{ xl: 7, md: 4, sm: 3 }}
        id="topic-carousel"
      >
        {carouselCards}
      </CardCarousel>
    </TopicCarouselWrapper>
  );
};

export default TopicCarousel;
